import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'es-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  @Input() error: string;
  @Input() loaded: boolean;
  @Input() loading: boolean;
  @Output()
  login: EventEmitter<{
    username: string;
    password: string;
  }> = new EventEmitter<{ username: string; password: string }>();

  loginForm: FormGroup;

  constructor(fb: FormBuilder) {
    this.loginForm = fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  submit() {
    this.login.emit(this.loginForm.value);
  }
}
